/**
 * usePortfolios Hook
 *
 * React Query hook for fetching portfolio summaries with auto-refresh
 */

import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export interface Portfolio {
  portfolio_id: string;
  name: string;
  total_capacity_mwh: number | string; // PostgreSQL numeric returns as string
  total_sites: number | string;
  sites_online: number | string;
  sites_offline: number | string;
  sites_degraded: number | string;
  sites_maintenance: number | string;
  active_alarms: {
    critical: number | string;
    warning: number | string;
    info: number | string;
  };
}

interface PortfoliosResponse {
  success: boolean;
  data: Portfolio[];
}

export function usePortfolios() {
  return useQuery({
    queryKey: ['portfolios'],
    queryFn: async () => {
      const response = await api.get<PortfoliosResponse>('/v1/portfolios');
      return response.data.data;
    },
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 25000, // Consider data stale after 25 seconds
  });
}
